__turbopack_context__.v({
  "blue": "LocationSelect-module-scss-module__8ZBTCa__blue",
  "btn": "LocationSelect-module-scss-module__8ZBTCa__btn",
  "childrenWrapper": "LocationSelect-module-scss-module__8ZBTCa__childrenWrapper",
  "col": "LocationSelect-module-scss-module__8ZBTCa__col",
  "control": "LocationSelect-module-scss-module__8ZBTCa__control",
  "desc": "LocationSelect-module-scss-module__8ZBTCa__desc",
  "green": "LocationSelect-module-scss-module__8ZBTCa__green",
  "name": "LocationSelect-module-scss-module__8ZBTCa__name",
  "optionRoot": "LocationSelect-module-scss-module__8ZBTCa__optionRoot",
  "orange": "LocationSelect-module-scss-module__8ZBTCa__orange",
  "red": "LocationSelect-module-scss-module__8ZBTCa__red",
  "root": "LocationSelect-module-scss-module__8ZBTCa__root",
  "row": "LocationSelect-module-scss-module__8ZBTCa__row",
});
